<kendo-dialog-titlebar
    class="mb-2 flex items-center gap-1 bg-background px-4 py-6 text-xl font-bold text-primary"
    translate
    (close)="close()">
    <div class="flex w-full items-center gap-2">
        <ng-icon name="faSolidGasPump" size="25px" />
        <div class="text-lg">{{ 'Add bunkering' | translate }}</div>
    </div>
</kendo-dialog-titlebar>
<div class="flex size-full flex-col gap-2 p-3">
    <!-- <app-card hostClass="border border-primary dark:bg-primary/10 bg-primary/10">
        <div class="px-2 py-2">
            {{ 'VESSEL INFORMATION' | translate }}
        </div>
        <div class="grid w-full grid-cols-3 gap-2 p-2">
            <app-control label="Vessel" type="string" [isEditMode]="false" [(ngModel)]="vesselInformation.vesselName" />
            <app-control
                label="IMO"
                type="string"
                [isEditMode]="false"
                [(ngModel)]="vesselInformation.imo"></app-control>
            <app-control
                label="Voyage code"
                type="string"
                [isEditMode]="false"
                [(ngModel)]="vesselInformation.voyageCode"></app-control>
        </div>
    </app-card> -->
    <div class="grid w-full grid-cols-2 gap-2">
        <app-control
            label="Bunker Type"
            type="codelist"
            id="bunkerTypeId"
            codelist="BunkerType"
            [required]="true"
            [isEditMode]="true"
            [(ngModel)]="model.bunkerTypeId" />
        <app-control
            label="Fuel Type"
            type="codelist"
            codelist="FuelType"
            [required]="true"
            [isEditMode]="true"
            [(ngModel)]="model.fuelTypeId"></app-control>
        <app-control
            label="Date"
            type="datetime"
            [required]="true"
            [isEditMode]="true"
            [(ngModel)]="model.date"></app-control>
        <app-control label="Date to" type="datetime" [isEditMode]="true" [(ngModel)]="model.dateTo"></app-control>
        <app-control label="Quantity" type="number" [isEditMode]="true" [(ngModel)]="model.quantity" />
        <app-control label="Vehicle Number" type="string" [isEditMode]="true" [(ngModel)]="model.vehicleNumber" />
        <app-control
            label="Berth"
            type="codelist"
            id="berthId"
            codelist="Berth"
            [isEditMode]="true"
            [(ngModel)]="model.berthId" />
    </div>
    <app-control
        label="Supplier Data"
        type="textarea"
        [rows]="3"
        [isEditMode]="true"
        [(ngModel)]="model.remark"></app-control>
    <app-control
        label="File"
        type="file"
        [multi]="false"
        [isEditMode]="true"
        [disabled]="false"
        [fileRestrictions]="{ allowedExtensions: extensions }"
        [(ngModel)]="model.attachment" />
    <kendo-dialog-actions class="flex w-full items-center gap-2">
        <div class="flex w-full items-center justify-end gap-2">
            <app-button class="w-[65px]" variant="secondary" (click)="close()">
                {{ 'Cancel' | translate }}
            </app-button>
            <app-button class="w-[70px]" variant="primary" [disabled]="!canConfirm()" (click)="confirm()">
                {{ 'Save' | translate }}
            </app-button>
        </div>
    </kendo-dialog-actions>
</div>
